import { generateColor } from "./routes";

export const generateSectionColors = (sections) =>
  sections.map((section, index) => ({
    ...section,
    ...generateColor(index),
    days: [0, 1, 2, 3, 4, 5, 6].reduce((acc, dayOfWeek) => {
      acc[dayOfWeek] = {
        ...section.days[dayOfWeek],
        drivers: section.days[dayOfWeek].drivers.map((driver, driverIndex) => ({
          ...driver,
          ...generateColor(driverIndex),
        })),
      };
      return acc;
    }, {}),
  }));

export const validateSection = ({ sectionEdit, sections }) => {
  const errors = {};

  if (!sectionEdit.sectionName)
    errors["sectionName"] = `Section name cannot be empty.`;
  else if (sectionEdit.sectionName.length > 10)
    errors["sectionName"] = `Section name is too long.`;
  else if (
    sections.find(
      ({ sectionCode, sectionName }) =>
        sectionCode !== sectionEdit.sectionCode &&
        sectionName === sectionEdit.sectionName
    )
  )
    errors["sectionName"] = `Section name is already taken.`;

  return errors;
};
